import each from 'lodash/each';
import map from 'lodash/map';
import debounce from 'lodash/debounce';
import { Directive, ElementRef, AfterViewInit, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[fixChildrenWidths]',
})
export class FixChildrenWidthsDirective implements AfterViewInit {
  @Input() shouldResizeOnWindowResize = true;
  private el: HTMLElement;
  private debouncedReAdjustWidths: () => void = debounce(this.reAdjustWidths.bind(this), 100);

  constructor(el: ElementRef) {
    this.el = el.nativeElement;
  }

  public ngAfterViewInit(): void {
    const children: HTMLElement[] = Array.from(this.el.children) as HTMLElement[];
    this.calculateAndSetWidths(children);
  }

  @HostListener('window:resize')
  private onResize(): void {
    if (this.shouldResizeOnWindowResize) this.debouncedReAdjustWidths();
  }

  private reAdjustWidths(): void {
    const parent: HTMLElement = this.el.parentElement;
    const children: HTMLElement[] = Array.from(this.el.children) as HTMLElement[];
    const oldParentPosition: string = parent.style.position;
    const oldParentWidth: string = parent.style.width;
    if (oldParentPosition === 'fixed') {
      parent.style.position = '';
      parent.style.width = '';
    }
    this.resetElementWidths(children);
    this.calculateAndSetWidths(children);
    parent.style.position = oldParentPosition;
    if (parent.style.position === 'fixed') parent.style.width = parent.offsetWidth + 'px';
    else parent.style.width = oldParentWidth;
  }

  private calculateAndSetWidths(elementList: HTMLElement[]): void {
    each(map(elementList, (element: HTMLElement) => element.offsetWidth),
      (width: number, i: number) => elementList[i].style.width = width + 'px')
    ;
  }

  private resetElementWidths(elementList: HTMLElement[]): void {
    each(elementList, (element: HTMLElement) => element.style.width = '');
  }
}
